import React from 'react';
import useFetch from '../../hooks/useFetch';
import './Featured.css';
import AddisAbaba from "../../assets/images/Addis_Ababa.jpeg"
import Adama from "../../assets/images/Adama.jpg"
import DebreZeyit from "../../assets/images/DebreZeyit.jpg"
import BahirDar from "../../assets/images/Bahir-Dar.jpeg"
import Hawassa from "../../assets/images/Hawassa.jpeg"


export default function Featured() {

    const { data, loading, error } = useFetch("/hotels/countByCity?cities=Addis Ababa,Adama,Debre Zeyit");
    console.log(data);

    return (
        <div className="featured">
            {loading ? <div className='flex'>
                <div style={{ borderTopColor: "transparent" }} className="w-8 h-8 border-4 border-blue-200 rounded-full animate-spin"></div>
                <p className='ml-2'>Loading..</p>
            </div> : (<><div className="featuredItem">
                <img
                    src={AddisAbaba}
                    alt=""
                    className="featuredImg"
                />
                <div class="absolute inset-0 bg-black bg-opacity-40  group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                <div className="featuredTitles">
                    <h1>Addis Ababa</h1>
                    <h2>{data[0]} properties</h2>
                </div>
            </div>

                <div className="featuredItem">
                    <img
                        src={Adama}
                        alt=""
                        className="featuredImg"
                    />
                    <div class="absolute inset-0 bg-black bg-opacity-40 group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                    <div className="featuredTitles">
                        <h1>Adama</h1>
                        <h2>{data[1]} properties</h2>
                    </div>
                </div>
                <div className="featuredItem">
                    <img
                        src={DebreZeyit}
                        alt=""
                        className="featuredImg"
                    />
                    <div class="absolute inset-0 bg-black bg-opacity-40 group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                    <div className="featuredTitles">
                        <h1>Debre Zeyit</h1>
                        <h2>{data[2]} properties</h2>
                    </div>
                </div>
                <div className="featuredItem">
                    <img
                        src={BahirDar}
                        alt=""
                        className="featuredImg"
                    />
                    <div class="absolute inset-0 bg-black bg-opacity-40 group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                    <div className="featuredTitles">
                        <h1>Bahir Dar</h1>
                        <h2>{data[2]} properties</h2>
                    </div>
                </div>
                <div className="featuredItem">
                    <img
                        src={Hawassa}
                        alt=""
                        className="featuredImg"
                    />
                    <div class="absolute inset-0 bg-black bg-opacity-40 group-hover:opacity-75 transition duration-300 ease-in-out"></div>

                    <div className="featuredTitles">
                        <h1>Hawassa</h1>
                        <h2>{data[2]} properties</h2>
                    </div>
                </div>


            </>)}
        </div>
    )
}
